import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/docs/')({
  // This route has no content of its own. Resolve it before rendering so
  // crawlers and non-JavaScript clients receive the same permanent redirect.
  beforeLoad: () => {
    throw redirect({ href: '/docs/introduction', statusCode: 301 })
  },
})
